import React, { useEffect, useState } from 'react';
import { Button, Item, Label } from 'semantic-ui-react';
import * as moment from 'moment-timezone';
import './Series.scss';
import { head } from 'ramda';

export const SeriesPost = ({ post, siteId, removeItem, moveUp, moveDown, updatePost, setBannerImage }) => {
  const [author, setAuthor] = useState('');
  const [authorAvatar, setAuthorAvatar] = useState('');
  const [current, setCurrent] = useState(post);
  const [views, setViews] = useState('');

  useEffect(() => {
    if (current.author) {
      setAuthor(current.author);
      setViews(current.total_views);
    }

    if (current.roar_authors.length) {
      setAuthor(current.roar_authors.map(a => a.title).join(','));
      setAuthorAvatar(head(current.roar_authors).avatar);
      setViews(current.stats.page_views_count);
    }
  }, [post]);

  const isEvent = () =>
    post?.sections?.map(section => (section ? section.toString().toUpperCase() : '')).includes('EVENTS');

  useEffect(() => setCurrent(post), [post]);

  const imageUrl = current.image_url ? current.image_url : current.teaser_image || current.image;

  const getPost = () => (
    <Item className="post-item-container">
      {current.promoted && (
        <Item.Image
          label={{ color: 'blue', ribbon: true, content: 'Promoted' }}
          size="small"
          className="post-image-preview"
          src={current.image_url ? current.image_url : current.teaser_image || current.image}
        />
      )}

      {!current.promoted && (
        <Item.Image
          size="small"
          className="post-image-preview"
          src={current.image_url ? current.image_url : current.teaser_image || current.image}
        />
      )}

      <Item.Content>
        <Item.Header as="a" href={current.url ? current.url : current.post_url} target="_blank">
          {current.headline}
        </Item.Header>
        <Item.Extra>
          <Label image as="a" href={current.author_profile_url} target="_blank">
            <img src={authorAvatar} alt="author" />
            {author}
          </Label>

          <Label>
            {isEvent() ? 'Event Date' : 'Date Published'}
            {/* updated_ts, last_published_ts, inserted_ts */}
            <Label.Detail>{moment.unix(current.created_ts).tz('America/Chicago').format('LLLL')}</Label.Detail>
          </Label>

          <Label>
            Views
            <Label.Detail>{views}</Label.Detail>
          </Label>

          <Button content="Remove from Series" floated="right" negative onClick={() => removeItem(post)} />
          <Button content="Set as Banner Image" floated="right" onClick={() => setBannerImage(imageUrl)} />
          {/* <Button icon="arrow up" size="mini" floated="right" onClick={moveUp} />
          <Button icon="arrow down" size="mini" floated="right" onClick={moveDown} /> */}
        </Item.Extra>
      </Item.Content>
    </Item>
  );

  return <>{post && getPost()}</>;
};

export default SeriesPost;
